<template>
    <div class="text-sm">
        <span v-for="(o, i) in options" :key="i" @click="$emit('update:modelValue', i)" class="font-bold ">
            <span class="cursor-pointer underline" :class="[modelValue === i ?'text-next-atp decoration-next-atp': 'hover:text-next-orange']">{{ o }}</span><span v-if="i !== options.length-1"> / </span>
        </span>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'Switcher',
    components: {
    },
    props: {
        modelValue: Number,
        options: Array
    },
})
export default class Switcher extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
